import { ProductItem } from '@/lib/types/api';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { getCategoryUrl } from '@/lib/data-transformer/gindumacUtils';

export function ProductBreadCrumbs({ product }: { product: ProductItem }) {
  const { t } = useTranslation('products');
  const category = t(product.machine_categories[0].name);
  const link = getCategoryUrl(product.machine_categories[0].name);
  return (
    <div className='no-print container w-full px-4 py-2 text-sm font-light'>
      <ul className='flex max-w-[90vw] flex-wrap items-center space-x-1'>
        <li className="inline-block text-muted-500 after:content-['>']">
          <Link href='/'>GINDUMAC</Link>
        </li>
        <li className="inline-block text-muted-500 after:content-['>']">
          <Link href='/products'>{t('products:PRODUCTS_NAME')}</Link>
        </li>
        {category ? (
          <li className="inline-block text-muted-500 after:content-['>']">
            <Link href={link}>{category}</Link>
          </li>
        ) : null}

        <li className='inline-block text-muted-500 '>{product.seo_title}</li>
      </ul>
    </div>
  );
}
